import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAddresses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('directory/addresses', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteAddress(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`directory/addresses/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
